<template>
  <div class="rank-container">
    <h2 class="title">高考位次查询</h2>
    <el-form
      :model="searchForm"
      :rules="searchFormRules"
      ref="searchFormRef"
      label-width="100px"
    >
      <!-- 选择专业批次 -->
      <el-form-item prop="piciSelectedOption">
        <el-select
          v-model="searchForm.piciSelectedOption"
          placeholder="请选择专业批次"
        >
          <el-option
            v-for="item in piciOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 首选科目 -->
      <el-form-item prop="selectedMainSubject">
        <el-select
          v-model="searchForm.selectedMainSubject"
          placeholder="请选择首选科目"
        >
          <el-option
            v-for="item in subjectNametoId.slice(0, 2)"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 再选科目 -->
      <el-form-item prop="selectedSecondSubjects">
        <el-select
          v-model="searchForm.selectedSecondSubjects"
          multiple
          placeholder="请选择再选科目"
        >
          <el-option
            v-for="item in subjectNametoId.slice(2)"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 输入分数 -->
      <el-form-item prop="score" class="score-form-item">
        <el-input
          @keyup.native.enter="getScore"
          v-model.number="searchForm.score"
          placeholder="请输入您的分数"
        ></el-input>
      </el-form-item>
      <!-- 位次查询按钮 -->
      <el-button
        type="primary"
        icon="el-icon-search"
        size="mini"
        @click="getScore"
        >位次查询</el-button
      >
    </el-form>

    <div class="result-box" v-if="resultList.length">
      <p>
        您输入的分数为: <span>{{ searchForm_clone.score }}</span>
      </p>

      <div v-if="searchForm_clone.piciSelectedOption === '本科批国家专项计划'">
        抱歉，目前没有本科批国家专项计划一分一段位次表数据，考生可直接进入院校推荐模块输入位次生成志愿推荐列表
      </div>

      <div v-else class="rank-box">
        <p v-for="item in resultList" :key="item.year">
          根据《湖北省{{
            item.year
          }}年普通高校招生排序成绩——理工类》您的综合成绩排序位次为:<span>{{
            item.sum
          }}</span>
        </p>
        <p>
          为了帮助考生合理的构建志愿布局，结合考生成绩与近几年高考招生数据，我们为考生划分了“冲”“稳”“保”3个层次,在<span
            >{{ rank.minRank }}</span
          >到<span>{{ rank.maxRank }}</span
          >位次区间内为考生和家长进行院校专业组智能推荐。
        </p>
      </div>

      <p>考生可点击下方按钮根据2021年高考位次进行院校专业组智能推荐查询</p>
      <el-button type="primary"
        ><router-link
          :to="{
            path: '/recommend/volunteer',
            query: {
              wc: weici_2021,
              typeName: searchForm_clone.selectedMainSubject
                ? '历史类'
                : '物理类',
              batchName: searchForm_clone.piciSelectedOption,
              code: subjectCollectionCode,
            },
          }"
          >智能推荐</router-link
        ></el-button
      >
    </div>

    <div class="row">
      <h2>使用流程</h2>
      <div class="using-box">
        <img src="../../assets/img/index-using.png" />
      </div>
      <div class="using-discribe">
        <a>选择专业信息</a>
        <a>输入高考成绩</a>
        <a>查询高考位次</a>
        <a>点击生成志愿推荐列表</a>
      </div>
    </div>

    <div class="footer">
      <span>数据来源:湖北省教育考试院</span>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import recommend from "../../api/recommend";
export default {
  name: "query",
  data() {
    const checkScore = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("分数不能为空"));
      }
      if (value < 150) {
        callback(new Error("分数不能小于150"));
      } else if (value > 750) {
        callback(new Error("分数不能大于750"));
      } else {
        callback();
      }
    };
    const checkSelectedSecondSubjects = (rule, value, callback) => {
      if (!value.length) {
        return callback(new Error("请选择再选科目"));
      }
      if (value.length !== 2) {
        return callback(new Error("请选择两门再选科目"));
      } else {
        callback();
      }
    };
    return {
      subjectNametoId: [
        { name: "物理", id: 0 },
        { name: "历史", id: 1 },
        { name: "化学", id: 2 },
        { name: "生物", id: 3 },
        { name: "思想政治", id: 4 },
        { name: "地理", id: 5 },
      ],
      subjectCollectionToCode: [
        { collection: [0, 2, 3], code: "KZ01" },
        { collection: [0, 2, 4], code: "KZ02" },
        { collection: [0, 2, 5], code: "KZ03" },
        { collection: [0, 3, 4], code: "KZ04" },
        { collection: [0, 3, 5], code: "KZ05" },
        { collection: [0, 4, 5], code: "KZ06" },
        { collection: [1, 2, 3], code: "KZ07" },
        { collection: [1, 2, 4], code: "KZ08" },
        { collection: [1, 2, 5], code: "KZ09" },
        { collection: [1, 3, 4], code: "KZ10" },
        { collection: [1, 3, 5], code: "KZ11" },
        { collection: [1, 4, 5], code: "KZ12" },
      ],
      piciOptions: [
        {
          value: "本科批",
          label: "本科批",
        },
        {
          value: "专科批",
          label: "专科批",
        },
        {
          value: "本科批国家专项计划",
          label: "本科批国家专项计划",
        },
      ],
      searchForm: {
        piciSelectedOption: "",
        selectedMainSubject: "",
        selectedSecondSubjects: [],
        score: "",
      },
      rank: {
        minRank: "",
        maxRank: "",
      },
      searchFormRules: {
        piciSelectedOption: [
          { required: true, message: "请选择专业批次", trigger: "blur" },
        ],
        selectedMainSubject: [
          { required: true, message: "请选择首选科目", trigger: "blur" },
        ],
        selectedSecondSubjects: [
          { validator: checkSelectedSecondSubjects, trigger: "blur" },
        ],
        score: [{ validator: checkScore, trigger: "blur" }],
      },
      resultList: [], // 点击位次查询按钮后返回的三年数据
      weici_2021: "",
      searchForm_clone: [], // 发起请求后，保存的一份searchForm数据
    };
  },
  computed: {
    subjectCollectionCode() {
      return this.subjectCollectionToCode.find((item) => {
        return (
          [
            this.searchForm.selectedMainSubject,
            ...this.searchForm.selectedSecondSubjects,
          ]
            .sort()
            .join() === item.collection.join()
        );
      }).code;
    },
  },
  methods: {
    getScore() {
      this.$refs.searchFormRef.validate(async (valid) => {
        if (valid) {
          const res = await recommend.query({
            score: this.searchForm.score,
            typeName: this.searchForm.selectedMainSubject ? "历史类" : "物理类",
            batchName: this.searchForm.piciSelectedOption,
          });
          if (res.code !== 20000) return this.$message.error("请求失败！");
          this.searchForm_clone = _.cloneDeep(this.searchForm); // 如果使用this.searchForm进行下方结果的条件渲染，用户重新选择下拉框后，会发生重新渲染
          console.log("daaaa", res);
          this.rank = res.rank;
          this.resultList = res.list; // 返回的三年数据
          this.weici_2021 = res.list[0].sum;
          console.log(this.weici_2021, this.resultList);
          console.log(this.subjectCollectionCode);
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
h2.title {
  height: 80px;
  margin-bottom: 30px;
  background-image: url("../../assets/img/back1.png");
  background-size: cover;
  line-height: 80px;
  text-align: center;
  font-weight: 400;
  font-size: 30px;
  color: #fff;
  letter-spacing: 10px;
}

.el-form {
  display: flex;
  margin-left: 50px;
}

.el-form-item.score-form-item {
  margin-right: 20px;
}

.el-form .el-button {
  height: 40px;
}

div.result-box {
  margin-left: 155px;
  line-height: 30px;
  font-size: 22px;
}

div.result-box span {
  color: #f00;
}

div.result-box .el-button {
  margin-top: 15px;
}

div.result-box .el-button span a {
  color: #fff;
}

// 使用流程的样式
.row {
  padding-top: 100px;
  position: relative;
  width: 1180px;
  margin: 0 auto;
}
.using-box {
  padding-top: 20px;
  text-align: center;
}
.using-discribe {
  font-size: 24px;
}
.using-discribe a:nth-child(1) {
  margin-left: 70px;
}
.using-discribe a:nth-child(2) {
  margin-left: 150px;
}
.using-discribe a:nth-child(3) {
  margin-left: 160px;
}
.using-discribe a:nth-child(4) {
  margin-left: 100px;
}

.footer span {
  float: right;
  color: black;
  font-size: 13px;
  margin-top: 150px;
  margin-right: 20px;
}
</style>